function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".surveillance-icon{fill:url(#surveillance);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "surveillance",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#038FC7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7B00FF"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "surveillance-icon",
  d: "M741.4,487.6c-5.3,0-10.6-0.8-15.8-2.4L109,296.9c-6.8-2.1-12.5-6.7-15.9-13c-3.4-6.3-4.1-13.6-2-20.4L139,106.7   c2.1-6.8,6.7-12.5,13-15.9c6.3-3.4,13.6-4.1,20.4-2l749.6,229.1c14.1,4.3,22.1,19.3,17.9,33.4l-3.1,10.3c-4,13-12.4,23.8-23.8,30.7   l-97.4,59.4l-45.8,27.9C761.2,484.9,751.3,487.6,741.4,487.6z M164.7,107.7c-1.1,0-2.2,0.3-3.2,0.8c-1.6,0.9-2.8,2.3-3.3,4   l-47.9,156.7c-0.5,1.7-0.3,3.6,0.5,5.2c0.9,1.6,2.3,2.8,4,3.3l616.6,188.4c9.4,2.9,19.6,1.6,28.1-3.6l45.8-27.9l97.4-59.4   c7.2-4.3,12.5-11.2,15-19.4l3.1-10.3c1.1-3.6-0.9-7.4-4.5-8.5L166.7,108C166,107.8,165.4,107.7,164.7,107.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "surveillance-icon",
  d: "M149.4,936.3H82.8V641.2h66.5c27.3,0,49.5,22.2,49.5,49.5v196.1c0.1,13.2-5,25.6-14.4,34.9   C175.1,931.1,162.6,936.3,149.4,936.3z M102.8,916.3h46.6c7.9,0,15.3-3.1,20.9-8.7c5.5-5.6,8.6-12.9,8.5-20.8V690.7   c0-16.3-13.2-29.5-29.5-29.5h-46.5V916.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "surveillance-icon",
  d: "M314.8,800.6H188v-20h126.8c37.2,0,67.5-30.3,67.5-67.5V585.7h20v127.4C402.3,761.3,363,800.6,314.8,800.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "surveillance-icon",
  d: "M737.1,652.3c-2.6,0-5.2-0.4-7.8-1.2l-304.4-93l2.4-9.3c0.9-3.3,1.3-6.6,1.3-9.7c0-20.1-16.3-36.4-36.4-36.4   c-15.6,0-29.5,9.9-34.5,24.7l-3.1,9.2l-252.8-77.2c-14.1-4.3-22-19.3-17.7-33.5l44-144.2L731.2,466c9.4,2.9,19.7,1.6,28.2-3.6   l68.2-41.6l-64.9,212.4C759.3,644.9,748.6,652.3,737.1,652.3z M448.4,544.4L735.1,632c3.6,1.1,7.4-0.9,8.5-4.5l49.5-162.2   l-23.4,14.2c-13.4,8.1-29.5,10.1-44.4,5.6L141.3,306.8l-38.2,125c-1.1,3.6,0.9,7.4,4.5,8.5l235,71.8c9.8-17.9,28.6-29.3,49.6-29.3   c31.1,0,56.4,25.3,56.4,56.4C448.6,540.9,448.5,542.7,448.4,544.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "surveillance-icon",
  d: "M824,604.8c-2,0-4.1-0.3-6.2-0.9l-61.1-18.6l44-144.1l61.2,18.7c11.1,3.6,17.3,15.5,14,26.6l0,0l-31.5,103.2   C841.7,598.8,833.2,604.8,824,604.8z M781.7,572l41.9,12.8c0.7,0.2,1.5-0.2,1.7-0.9l31.5-103.2c0.2-0.7-0.2-1.5-1-1.8L814,466.1   L781.7,572z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "surveillance-icon",
  x: 207.2,
  y: 226.5,
  transform: "matrix(0.9564 0.2921 -0.2921 0.9564 81.4251 -72.4548)",
  width: 152.3,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  className: "surveillance-icon",
  d: "M392.2,595.7c-31.1,0-56.4-25.3-56.4-56.4c0-6,1-12.1,2.9-18l0.1-0.2c7.9-22.9,29.4-38.2,53.5-38.2   c31.1,0,56.4,25.3,56.4,56.4c0,5.2-0.7,10.2-2,14.8C440,578.6,417.7,595.7,392.2,595.7z M357.7,527.4c-1.3,4-1.9,8-1.9,11.9   c0,20.1,16.3,36.4,36.4,36.4c16.5,0,30.9-11.1,35.1-26.9l0-0.1c0.8-2.9,1.2-6.1,1.2-9.5c0-20.1-16.3-36.4-36.4-36.4   C376.7,502.8,362.8,512.7,357.7,527.4z"
}));

function SvgSurveillance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveillance);
export default __webpack_public_path__ + "static/media/surveillance.e6fcbf44.svg";
export { ForwardRef as ReactComponent };